define('shoptheme/components/product/view',[
	"require",
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/dom/event/trigger",
	"json!shoptheme/etc/breakpoints.json",
	"enquire",
	"modernizr",
	"bootstrap-affix"
], function(
	require,
	$,
	_,
	Component,
	BEM,
	Registry,
	triggerEvent,
	BreakPoints,
	enquire
) {
	var $window = $(window);

	function scrollToFragment(url) {
		var id, fragmentMatches, target, treshold;

		fragmentMatches = url.match(/[#&](tab-.*)$/);

		if (!fragmentMatches || fragmentMatches.length < 2) return;

		id = fragmentMatches[1];
		target = $('#' + id);

		if (!target.length) return;

		treshold = target.height() / 2;

		$('html:not(:animated),body:not(:animated)').animate({
			scrollTop: target.offset().top - treshold
		}, {
			duration: 600
		});
		
		if (('' + document.location).indexOf('#') < 0) {
			document.location = document.location + '#' + id;
		}

		setTimeout(function() {
			target.click();
		}, 10);
	}

	return Component.create({
		block:					null,
		purchaseBlock:			null,

		affixElement:			null,

		productOrder:			null,
		productOrderSlots:		null,

		productOther:			null,
		productOtherSlots:		null,

        productName:            null,
        originalProductName:    null,

		shortDescription:		null,
		originalShortDescription: null,

		//addToCartButton:		null,

		$init: function() {
			this.block = BEM.block("product-view");
			this.purchaseBlock = BEM.block("block:modifier(purchase)");

			this.affixElement = this.block.getElements('affix');

			this.productOrder = this.block.getElements("product-order");
			this.productOrderSlots = {
				mobile: this.block.getElements("product-order-mobile"),
				desktop: this.block.getElements("product-order-desktop")
			};

			this.productOther = this.block.getElements("product-other");
			this.productOtherSlots = {
				mobile: this.block.getElements("product-other-mobile"),
				desktop: this.block.getElements("product-other-desktop")
			};

            this.productName = this.block.getElements("name");
            this.originalProductName = this.productName.html();

			this.shortDescription = this.block.getElements("short-description");
			this.originalShortDescription = this.shortDescription.html();

			$(document).on('product/changeSimple', _.bind(this._onChangeSimple, this));
			$(document).on('product/changeGallerySimple', _.bind(this._onChangeSimple, this));

			$(document).on("click", 'a[href*="#tab-"]', function(e) {
				
				var $this = $(this);
				
				if ($this.hasClass('js-tab-reload') || $this.parents('.js-review-pagination').length) {
                    return ;
				}
                
                e.preventDefault();

				var href = $this.attr('href'),
					pattern = /^([a-zA-Z]*:\/\/)?([^\/]+).*(\/.*)$/,
					match = (''+document.location).replace(pattern, "$1$2$3").replace(/#.*/, '') === href.replace(pattern, "$1$2$3").replace(/#.*/, '');

				if (match) {
					scrollToFragment(href);
				}
			});
			
			/* scroll to fragment after loading complete of page */
			$(window).load(function() {
                if (('' + document.location).indexOf('#') != -1) {
                    scrollToFragment('' + document.location);
                }
            });

			this.initResponsive();
			this.initAffixPlaceholders();

			//var addToCartForm = $('#product_addtocart_form')
			//	, addToCartContainer = addToCartForm.find('.add-to-cart-button-wrap');
			//
			//this.addToCartButton = addToCartContainer.find('button');

			//this.adviseAddToCartForm();

			this.adviseRenderFunction();
		},

		initResponsive: function() {
			enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
				match: _.bind(this.layoutDesktop, this),
				unmatch: _.bind(this.layoutMobile, this)
			}, true);
		},

		initAffixPlaceholders: function() {
			var element = this.affixElement,
				placeholder = $('<div class="affix-placeholder">');

			var layout = function() {
				placeholder.height(element.outerHeight(true));
			};

			element.after(placeholder);

			$window.on("resize click", _.debounce(layout, 150));
			Registry().retrieve("product.view.configurable.spConfig", _.debounce(layout, 150));
			element.on("affix.bs.affix", layout);
			layout();
		},

		layoutMobile: function() {
			this.productOrderSlots.mobile.append(this.productOrder);
		},

		layoutDesktop: function() {
			var $document = $(document),
				$header = BEM.block("header"),
				$bottomStopElement = this.block.getElements('col--main'),
				$sidebar = this.block.getElements('col--side'),
				lock = false;

			var self = this;

			this.productOrderSlots.desktop.append(this.productOrder);

			function calculateBottom() {
				return Math.max(
					$bottomStopElement.offset().top + $bottomStopElement.outerHeight(true),
					$sidebar.offset().top + $sidebar.outerHeight(true)
				);
			}

			this.affixElement.affix({
				offset: {
					top: $header.offset().top + $header.outerHeight(true),
					bottom: function() {
						if (lock) {
							return null;
						}

						var bottom = calculateBottom();
						return $document.height() - bottom;
					}
				}
			});

			this.affixElement.on("affix.bs.affix", _.bind(function(e) {
				var headerBottom = $header.offset().top + $header.height(),
					purchaseHeight = this.affixElement.outerHeight(true),
					purchaseOffset = this.affixElement.offset(),
					windowHeight = $window.height(),
					affix = this.affixElement.data("bs.affix");

				lock = false;

				if (windowHeight < purchaseHeight + purchaseOffset.top - headerBottom) {
					e.preventDefault();
					affix.affixed = null;
					lock = true;
				}

				var bottom = calculateBottom();
				if (bottom <= purchaseOffset.top + purchaseHeight) {
					e.preventDefault();
				}

			}, this));
		},

		adviseRenderFunction: function() {
			if ("function" === typeof render) {
				var _orig = render,
					self = this;

				render = function() {
					_orig.apply(this, arguments);

					var affix = self.affixElement.data('bs.affix');

					if (affix) {
						affix.checkPositionWithEventLoop();
					}
				}
			}
		},

		_onChangeSimple: function(e, simple) {

			var productNameHtml = simple ? (simple["product_name"] || this.originalProductName)
                    : this.originalProductName,
                shortDescriptionHtml = simple ? (simple["short_description"] || this.originalShortDescription)
				    : this.originalShortDescription;

			this.productName.html(productNameHtml);
            this.shortDescription.html(shortDescriptionHtml);
		},

		//adviseAddToCartForm: function() {
		//	var self = this;
		//
		//	if ("undefined" == typeof productAddToCartForm) return;
		//
		//	var _submit = productAddToCartForm.submit;
		//
		//	productAddToCartForm.submit = function() {
		//		if (this.validator.validate()) {
		//			$.fn.button && self.addToCartButton.button('loading');
		//		}
		//		_submit.apply(this, arguments);
		//	};
		//},

		destructor: function() {
			//this.addToCartButton = null;
		}
	});
});
